/* eslint-disable react/prop-types */
import React from "react";
import {getDefaultOperatorForSimpleMode} from "components/Homeowner/Dashboard/QuickListConfig";
import {operatorNames} from "components/Homeowner/Dashboard/QuickListConfigOperatorNames";

export default class Rule extends React.Component {
  static get defaultProps() {
    return {
      id: null,
      parentId: null,
      field: null,
      operator: null,
      value: null,
      schema: null,
    };
  }

  constructor(props) {
    super(props);
    this.onElementChanged = this.onElementChanged.bind(this);
    this.onFieldChanged = this.onFieldChanged.bind(this);
    this.onOperatorChanged = this.onOperatorChanged.bind(this);
    this.onValueChanged = this.onValueChanged.bind(this);
    this.removeRule = this.removeRule.bind(this);

    if (this.props.simpleMode) {
      this.onOperatorChanged(getDefaultOperatorForSimpleMode(props.inputType));
    }
  }

  onFieldChanged(value) {
    this.onElementChanged("field", value);
  }

  onOperatorChanged(value) {
    this.onElementChanged("operator", value);
  }

  onValueChanged(value) {
    this.onElementChanged("value", value);
  }

  onElementChanged(property, value) {
    if (value === undefined) return;
    const {id, schema: {onPropChange}} = this.props;
    onPropChange(property, value, id);
  }

  removeRule(event) {
    event.preventDefault();
    event.stopPropagation();

    this.props.schema.onRuleRemove(this.props.id, this.props.parentId);
  }

  render() {
    let {
      field,
      operator,
      value,
      inputType,
      translations,
      schema: {fields, controls, getOperators, getLevel, classNames},
      activeTemplate,
    } = this.props;
    value = value || "";
    let level = getLevel(this.props.id);

    return (
      <div className={`rule ${classNames.rule}`} style={{ display: "flex", flexDirection: "row", width: "100%", gap: "10px" }}>
        {
          React.createElement(controls.fieldSelector,
            {
              options: fields,
              title: translations.fields.title,
              value: field,
              className: `rule-fields ${classNames.fields}`,
              handleOnChange: this.onFieldChanged,
              level: level,
              style: { flex: 1, minWidth: 0 },
            },
          )
        }
        {((operator !== operatorNames.Text && !this.props.simpleMode) || operator === operatorNames.True) &&
        React.createElement(controls.operatorSelector,
          {
            field: field,
            title: translations.operators.title,
            options: getOperators(field.value ? field.value : field).map(({name, label}) => ({value: name, label})),
            value: operator,
            className: `rule-operators ${classNames.operators}`,
            handleOnChange: this.onOperatorChanged,
            level: level,
            simpleMode: this.props.simpleMode,
            style: { flex: 1, minWidth: 0 },
          },
        )
        }
        {(!this.props.simpleMode || operator !== operatorNames.True) &&
        React.createElement(controls.valueEditor,
          {
            field: field,
            title: translations.value.title,
            operator: operator,
            value: value,
            className: `rule-value ${classNames.value}`,
            handleOnChange: this.onValueChanged,
            onOperatorChanged: this.onOperatorChanged,
            level: level,
            activeTemplate,
            inputType: inputType,
            simpleMode: this.props.simpleMode,
            style: { flex: 2, minWidth: 0 },
          },
        )
        }
        {
          React.createElement(controls.removeRuleAction,
            {
              label: translations.removeRule.label,
              title: translations.removeRule.title,
              className: `rule-remove ${classNames.removeRule}`,
              handleOnClick: this.removeRule,
              level: level,
              style: { flexShrink: 0 },
            })
        }
      </div>
    );
    //}
  }
}
